if (!window.Drupal) {
  window.Drupal = {
    t: function (str) {
      return str
    }
  }
}

export default {
  computed: {
    searchPlaceholder: () => Drupal.t('Search the Resources...', {}, {'context': 'resources-listing'}), 
    topicLabel: () => Drupal.t('Topic', {}, {'context': 'resources-listing'}), 
    resourceTypeLabel: () => Drupal.t('Resource Type', {}, {'context': 'resources-listing'}), 
    languageLabel: () => Drupal.t('Language', {}, {'context': 'resources-listing'}), 
    noResourcesFound: () => Drupal.t('No resources found. Please check other languages or filters.', {}, {'context': 'resources-listing'}),
    next: () => Drupal.t('next', {}, {'context': 'resources-listing'}), 
    last: () => Drupal.t('last', {}, {'context': 'resources-listing'}), 
    previous: () => Drupal.t('previous', {}, {'context': 'resources-listing'}), 
    first: () => Drupal.t('first', {}, {'context': 'resources-listing'}), 
    anyTopic: () => Drupal.t('any Topic', {}, {'context': 'resources-listing'}), 
    anyResourceType: () => Drupal.t('any Resource Type', {}, {'context': 'resources-listing'}), 
    filters: () => Drupal.t('Filters', {}, {'context': 'resources-listing'}),
    useFilters: () => Drupal.t('Use filters', {}, {'context': 'resources-listing'}),
    resourcesFilters: () => Drupal.t('Resources Filters', {}, {'context': 'resources-listing'})
  }
}
